<template>
  <div
    id="loyalty-point"
    class="mobile-card-select d-sm-none profile-account show"
    v-if="!domainBasedBrand"
  >
    <div class="select-card p-0 mb-0">
      <div class="checkout-card px-0">
        <div class="back-cart">
          <router-link
            :to="{ name: 'profile.personal-info' }"
            class="back-loyalty"
          >
            <svg class="rightarrow" fill="none">
              <use xlink:href="#left-arrow" />
            </svg>
          </router-link>
        </div>
        <h4>{{ _T('Loyalty point history') }}</h4>
        <div
          class="loyalty-lists"
          v-if="customer_loyalty_cards && customer_loyalty_cards.length"
        >
          <div v-for="(card, key) in customer_loyalty_cards" :key="key">
            {{ _T('Cashback points') }} {{ card.currency }}
            {{ Num.price(card.balance) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import LoyaltyDetails from './LoyaltyDetails'
import { mapGetters } from 'vuex'
export default {
  name: 'MobileLoyalty',
  components: {
    // LoyaltyDetails,
  },
  computed: {
    ...mapGetters(['_T', 'customer_loyalty_cards', 'domainBasedBrand']),
  },
}
</script>

<style lang="scss" scoped>
#loyalty-point,
#loyalty-use {
  &.hide {
    display: none;
  }
  &.show {
    display: block;
  }
}
.loyalty-lists {
  padding: $px23 $px20;

  .title-points {
    font-size: $px13;
    line-height: $px16;
    letter-spacing: 0.02em;
    color: $light-font;
    text-transform: uppercase;
  }

  ul {
    /deep/ li {
      display: block;
      padding: $px20 0;

      &:last-child {
        padding-bottom: 0;
      }

      + li {
        border-top: $px1 solid $light-border;
      }

      .media {
        justify-content: space-between;
        align-items: center;

        .font-success {
          color: $dine-success;
        }

        span {
          font-weight: 600;
          font-size: $px12;
          line-height: $px15;
          letter-spacing: 0.02em;
          color: $light-font;
        }

        .media-body {
          display: flex;

          .loyalty-img {
            width: $px42;
            height: $px42;
            border-radius: 100%;
            background-color: $color-primary-1;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: $px27;
            }
          }

          .list-content {
            margin-left: $px10;

            h6 {
              line-height: $px17;
              letter-spacing: 0.02em;
              margin-bottom: $px6;
            }
          }
        }

        .text-right {
          h6 {
            margin-top: $px4;
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
.mobile-card-select {
  .report-order {
    .problem-main {
      width: 100%;
      height: $px132;
      background-color: var(--primary-color-darken);
      h5 {
        color: $white;
        padding-top: $px26;
        font-weight: bold;
        font-size: $px16;
        letter-spacing: 0.01em;
        text-align: center;
      }
      .report-content {
        margin: $px20 $px20 $px95;
        .mobile-card {
          box-shadow: 0px $px4 $px20 rgba($black, 0.08);
          border-radius: $px5;
          background-color: $white;
          overflow: hidden;
          .header-report-card {
            padding: $px12 $px15;
            background-color: $light-border;
            h6 {
              display: inline-block;
              margin-left: $px10;
              font-weight: 600;
              line-height: $px17;
              letter-spacing: 0.05em;
              color: $black;
              margin-bottom: 0;
            }
            .icon-report {
              width: $px26;
              height: $px26;
              background-color: $white;
              border-radius: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: $px14;
              }
            }
          }
          .resto-report {
            li {
              display: block;
              padding: $px12 $px15;
              + li {
                border-top: $px1 solid $light-border;
                span {
                  font-weight: 600;
                  font-size: $px13;
                  line-height: $px16;
                  letter-spacing: 0.02em;
                }
                h6 {
                  font-weight: bold;
                  font-size: $px14;
                  line-height: $px17;
                  letter-spacing: 0.005em;
                  color: $font-color;
                }
              }
              h6 {
                float: right;
                display: inline-block;
                font-weight: 600;
                font-size: $px12;
                line-height: $px15;
                letter-spacing: 0.02em;
                color: $light-font;
                margin-bottom: 0;
              }
            }
          }
        }
        .tell-us {
          padding-top: $px24;
          h6 {
            font-weight: 600;
            font-size: $px13;
            line-height: $px16;
            letter-spacing: 0.02em;
            color: $light-font;
          }
          .form-group {
            margin-bottom: $px12;
            .form-control {
              border: $px1 solid $light-border;
              border-radius: $px4;
              height: $px100;
            }
            span {
              font-size: $px12;
              line-height: $px15;
              letter-spacing: 0.02em;
              color: $light-font;
            }
          }
          .add-photo {
            .row {
              margin: 0 -$px5;
              justify-content: space-around;
              > div {
                flex: 0 0 22%;
                max-width: 22%;
                padding: 0;
              }
            }
            .report-img {
              position: relative;
              > img {
                width: 100%;
                height: auto;
                border: $px1 solid $light-border;
                border-radius: $px4;
              }
              .close-link {
                position: absolute;
                top: $px2;
                right: $px2;
                width: $px20;
                height: $px20;
                background-color: $color-primary;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: $px4;
                img {
                  width: $px10;
                }
              }
            }
            .report-add {
              width: 100%;
              height: 100%;
              background-color: $light-border;
              border: $px1 solid $light-border;
              border-radius: $px4;
              display: flex;
              align-items: center;
              justify-content: center;
              svg {
                vertical-align: middle;
                path {
                  fill: $color-primary;
                }
              }
            }
          }
        }
      }
      .report-btn {
        padding: $px15 $px20;
        border-top: $px1 solid $light-border;
        background-color: $white;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
      }
    }
  }
}
.mobile-card-select {
  height: 100vh;
  position: relative;
  .checkout-card {
    text-align: center;
    padding: $px18 $px20;
    background-color: $white;
    border-bottom: $px12 solid $light-border;
    h4 {
      position: relative;
      margin-bottom: 0;
      font-weight: bold;
      text-transform: capitalize;
      .skip-this {
        font-weight: 600;
        font-size: $px14;
        line-height: $px17;
        letter-spacing: 0.02em;
        color: $light-font;
        position: absolute;
        right: $px2;
        top: $px4;
      }
    }
    .back-cart {
      position: absolute;
      top: $px18;
      left: $px20;
      z-index: 1;
      .rightarrow {
        width: $px16;
        height: $px16;
      }
    }
  }
  .my-account {
    padding: $px10 $px20 $px10;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: $px1 solid $light-border;
    h4 {
      margin-bottom: 0;
      font-weight: 600;
      font-size: $px18;
      letter-spacing: -0.02em;
    }
    .badge {
      float: right;
      color: rgba(var(--color-warning-color-source), 0.8);
      font-weight: normal;
      font-size: $px14;
      line-height: $px17;
      letter-spacing: 0.583333px;
      padding: $px4 $px10;
      background-color: rgba(var(--color-warning-color-source), 0.2);
      border-radius: $px6;
    }
  }
  .loyalty-point {
    > h6 {
      font-weight: 600;
      font-size: $px12;
      line-height: $px15;
      letter-spacing: 0.02em;
      color: $light-font;
      margin-bottom: 0 !important;
      text-transform: uppercase;
    }
    .media {
      margin-top: $px20;
      .media-body {
        margin-left: $px18;
        h6 {
          line-height: $px17;
          letter-spacing: 0.02em;
        }
        h4 {
          font-weight: 600;
          font-size: $px18;
        }
      }
    }
    ul {
      li {
        display: block;
        padding: $px26 0;
        a {
          color: $font-color;
          display: block;
        }
        + li {
          border-top: $px1 solid $light-border;
        }
        svg {
          vertical-align: -$px6;
        }
        h6 {
          display: inline-block;
          margin-bottom: 0;
          margin-left: $px4;
        }
        span {
          float: right;
        }
        .version {
          margin-left: 0;
          font-weight: normal;
          font-size: $px13;
          line-height: $px16;
          letter-spacing: 0.02em;
          color: $light-font;
        }
      }
    }
    .logout-btn {
      padding-bottom: $px65;
      button {
        border-width: $px2;
        svg {
          vertical-align: bottom;
          margin-right: $px2;
          path {
            fill: $primary-color;
          }
        }
        &:hover {
          svg {
            path {
              fill: $white;
            }
          }
        }
      }
    }
  }
  .media-user {
    padding: $px16;
    align-items: center;
    img {
      padding: $px4;
      border: $px1 solid $light-border;
      border-radius: 100%;
      width: $px74;
      height: $px74;
    }
    .media-body {
      padding-left: $px12;
      h5 {
        font-weight: 600;
        font-size: $px16;
        color: $black;
        margin-bottom: $px3;
      }
      span {
        font-size: $px13;
        line-height: $px16;
        display: block;
        letter-spacing: 0.02em;
        color: $light-font;
        margin-bottom: $px6;
      }
      a {
        font-weight: 600;
        font-size: $px13;
        line-height: $px16;
      }
    }
    &.text-center {
      img {
        width: $px82;
        height: $px82;
      }
      .change-photo {
        position: relative;
        a {
          &.icon-change {
            width: $px30;
            height: $px30;
            background-color: $primary-color;
            display: flex;
            align-items: center;
            justify-content: center;
            border: $px1 solid $white;
            border-radius: 100%;
            position: absolute;
            right: 40%;
            bottom: 0;
            img {
              padding: 0;
              border: none;
              width: auto;
              height: auto;
            }
          }
        }
        input {
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
          width: $px28;
          opacity: 0;
          bottom: 0;
          cursor: pointer;
        }
      }
    }
  }
  .select-card {
    padding: $px20;
    margin-bottom: $px12;
    + .select-card {
      margin-bottom: $px120;
      border-top: $px12 solid $light-border;
    }
    h6 {
      font-weight: 600;
      line-height: $px22;
      letter-spacing: 0.5px;
      margin-bottom: $px4;
    }
    .add-new-card {
      margin-top: 0;
      ul {
        li {
          display: block;
          label {
            span {
              text-align: left;
              padding: $px10 $px15;
              .media {
                .media-body {
                  margin-left: $px14;
                  span {
                    border: none;
                    padding: 0;
                    line-height: $px17;
                    letter-spacing: 0.04em;
                    color: $light-font;
                  }
                }
              }
            }
          }
          .link-add-card {
            padding: $px18;
            text-align: center;
            border: $px1 dashed $light-border;
            border-radius: $px4;
            a {
              font-weight: 600;
              letter-spacing: 0.04em;
            }
          }
        }
      }
    }
  }
  .added-product {
    li {
      display: flex;
      position: relative;
      min-height: $px87;
      &:last-child {
        min-height: $px70;
      }
      .detail {
        margin-left: $px18;
        width: 100%;
        h6 {
          font-weight: 600;
          font-size: $px14;
          line-height: $px17;
          letter-spacing: 0.02em;
          color: $font-color;
          text-transform: capitalize;
          margin-bottom: $px2;
          span {
            float: right;
          }
        }
        p {
          max-width: $px180;
          font-weight: normal;
          font-size: $px13;
          line-height: $px16;
          letter-spacing: 0.5px;
          color: $light-font;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          overflow: hidden;
          margin-bottom: 0;
        }
        a {
          font-weight: 600;
          font-size: $px14;
          line-height: $px17;
          letter-spacing: 0.02em;
          color: $warning-color;
          align-items: center;
          display: flex;
          margin-top: $px6;
          svg {
            margin-left: $px3;
          }
        }
      }
      .qty-box {
        margin-left: 0;
        position: absolute;
        right: 0;
        bottom: 0;
        .form-control {
          width: $px32;
          height: $px32;
        }
        .input-group {
          .btn {
            width: $px32;
          }
        }
      }
      + li {
        padding-top: $px20;
        margin-top: $px20;
        border-top: $px1 solid $light-border;
      }
    }
    .btn-add {
      width: 100%;
      border: $px1 dashed $light-border;
      border-radius: $px4;
      font-weight: 600;
      font-size: $px14;
      line-height: $px17;
      letter-spacing: 0.04em;
      color: $primary-color;
      background-color: $white;
      text-transform: capitalize;
      padding: $px15;
    }
  }
  &.profile-account {
    height: auto;
    .checkout-card {
      text-align: left;
      border-bottom: none;
      padding: 0;
      h4 {
        padding: $px10 $px20 $px10 $px50;
        border-bottom: $px1 solid $light-border;
        font-weight: 600;
      }
      .back-cart {
        top: $px10;
        .back-loyalty,
        .back-carry {
          img {
            width: $px16;
          }
        }
      }
    }
    .select-card {
      + .select-card {
        margin-bottom: 0;
      }
    }
  }
  .bill-amount {
    padding: $px15 $px20;
    border-top: $px18 solid $light-border;
    background-color: $white;
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 2;
    h6 {
      font-weight: bold;
      line-height: $px17;
      letter-spacing: 0.005em;
      margin-bottom: $px10;
      span {
        float: right;
        font-size: $px16;
        line-height: $px19;
      }
    }
  }
}
</style>
